<template>
    <div>
        <main>
            <router-view />
            <InfoModal v-if="store.getters.getUserInfoModalState" />
        </main>
    </div>
</template>

<script setup>
import InfoModal from '@/components/User/UserModal/InfoModal.vue';
import { useStore } from 'vuex';
const store = useStore();
</script>

<style>
@import "https://d3kx8o9mol3zjn.cloudfront.net/admin/css/common.css";
@import "https://d3kx8o9mol3zjn.cloudfront.net/admin/css/style.css";
</style>